module.exports = __webpack_public_path__ + "media/images/voucher-acab829a8f2a22947270391ca745af19.png";